import classNames from 'classnames';
import React from 'react';
import truncate from '../../helpers/truncate';

interface SelectProps {
  value: string | number;
  className?: string;
  onChange?: (value: string | number) => void;
  disabled?: boolean;
  allowEmptyOption?: boolean;
  options: unknown[];
  getValue?: (item: any) => string | number;
  getLabel?: (item: any) => string;
  emptyLabel?: string;
  variant?: 'v2';
  size?: 'sm' | 'xs';
  width?: number | 'auto';
  maxWidth?: number;
  emptyValueUndefined?: boolean;
  truncateLength?: number;
}

const Select = ({
  value,
  onChange,
  className,
  disabled,
  options,
  getValue,
  getLabel,
  allowEmptyOption,
  emptyLabel,
  variant,
  size,
  width,
  maxWidth,
  emptyValueUndefined,
  truncateLength,
}: SelectProps) => {
  const _onChange = (e) => {
    if (disabled) return;
    if (onChange) {
      if (e.target.value === '' && emptyValueUndefined) {
        onChange(undefined);
      } else {
        onChange(e.target.value);
      }
    }
  };

  const _getLabel = (item) => {
    let label: string;
    if (getLabel) {
      label = getLabel(item);
    } else if (item.label !== undefined) {
      label = item.label;
    } else if (item.name !== undefined) {
      label = item.name;
    } else {
      label = item;
    }

    if (truncateLength && typeof label === 'string') {
      return truncate(label, truncateLength);
    }

    return label;
  };

  const _getValue = (item) => {
    if (getValue) return getValue(item);
    if (item.value !== undefined) return item.value;
    if (item.id !== undefined) return item.id;

    return item;
  };

  const isOptionDisabled = (option) => {
    return option?.disabled;
  };

  return (
    <div
      className={classNames('worx-select-control', {
        'worx-select-control--v2': variant === 'v2',
        'worx-select-control--sm': size === 'sm',
        'worx-select-control--xs': size === 'xs',
        [className]: !!className,
      })}
      style={{ width, maxWidth }}
    >
      <select
        className={classNames('form-control', { 'form-control--v2': variant === 'v2' })}
        value={value === null ? '' : value}
        onChange={_onChange}
        disabled={disabled}
      >
        {(value === undefined || value === null || value === '' || allowEmptyOption) && (
          <option value="">{emptyLabel || ''}</option>
        )}

        {options?.map((optionGroupOrItem: any) => {
          if (
            optionGroupOrItem &&
            typeof optionGroupOrItem === 'object' &&
            'options' in optionGroupOrItem &&
            Array.isArray(optionGroupOrItem.options)
          ) {
            return (
              <optgroup label={optionGroupOrItem.label} key={optionGroupOrItem.label}>
                {optionGroupOrItem.options.map((opt) => (
                  <option
                    value={_getValue(opt)}
                    key={_getValue(opt)}
                    disabled={isOptionDisabled(opt)}
                  >
                    {_getLabel(opt)}
                  </option>
                ))}
              </optgroup>
            );
          }

          return (
            <option
              value={_getValue(optionGroupOrItem)}
              key={_getValue(optionGroupOrItem)}
              disabled={isOptionDisabled(optionGroupOrItem)}
            >
              {_getLabel(optionGroupOrItem)}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default Select;
